import { useEffect, useRef } from 'react';
import { AppRouter } from '@/router';
import { useAuth } from '@/hooks/useAuth';
import { useSocket } from '@/hooks/useSocket';
import { useNotifications } from '@/hooks/useNotifications';

export function App() {
  const { fetchMe } = useAuth();
  const didFetch = useRef(false);

  useSocket();
  useNotifications();

  useEffect(() => {
    if (didFetch.current) return;
    didFetch.current = true;
    fetchMe();
  }, []);

  return <AppRouter />;
}
